/* Kaffepro 2027 – Black Week »Tidlig adgang« popup, bar and sign-up (sections/ks-bw-lead.liquid, snippets/ks-bw-lead-form.liquid).
   Rules from Bedre Nætter, measured 22 Oct 2026 (#320): open at the first of N s on the page, P % scrolled or exit intent; again H hours
   after a close; never after sign-up. Not on top of the cookie banner or an open drawer, window or menu. Sign-up goes to Klaviyo's public
   subscriptions API (list »Newsletter«, the welcome flow's list) with bw26_early – the 12 Nov 19:00 mail goes to that segment (#314).
   The Black Week page uses the same form in its hero and shows [data-ksbw-phase] parts by the clock. */
(function (w, d) {
  'use strict';
  if (w.__ksbw) return; w.__ksbw = 1;
  var KEY = 'ks_bw26';
  function get() { try { return JSON.parse(w.localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function put(o) { try { w.localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function t(s, def) { var v = Date.parse(s || ''); return isNaN(v) ? def : v; }

  var root = d.querySelector('[data-ksbw]') || d.querySelector('[data-ksbw-page]');
  var cfg = root || d.documentElement;
  var EARLY = t(cfg.getAttribute('data-ksbw-early'), Date.UTC(2026, 10, 12, 18, 0, 0));
  var OPEN = t(cfg.getAttribute('data-ksbw-open'), Date.UTC(2026, 10, 12, 23, 0, 0));
  var END = t(cfg.getAttribute('data-ksbw-end'), Date.UTC(2026, 10, 30, 22, 59, 59));
  var COMPANY = cfg.getAttribute('data-company') || 'Rd9cLG', LIST = cfg.getAttribute('data-list') || 'RzuJDq';
  var now = Date.now();
  var phase = now < EARLY ? 'pre' : now < OPEN ? 'early' : now < END ? 'open' : 'after';
  /* preview only (owner 29 Oct: »what about the black week when its live?«): ?ksbw=pre|early|open|after shows that phase in an
     unpublished theme; the published theme always follows the clock */
  var force = /[?&]ksbw=(pre|early|open|after)(?:&|$)/.exec(w.location.search);
  if (force && w.Shopify && w.Shopify.theme && w.Shopify.theme.role && w.Shopify.theme.role !== 'main') phase = force[1];
  /* owner 1 Nov (#592): before the early-access hour nothing names the offers – ks-bw-lead.css blurs and hides by html.ksbw-pre;
     [data-ksbw-pre] holds the »pre« text of a line, or the alt of a picture */
  d.documentElement.classList.toggle('ksbw-pre', phase === 'pre');
  if (phase === 'pre') Array.prototype.forEach.call(d.querySelectorAll('[data-ksbw-pre]'), function (el) { if (el.tagName === 'IMG') el.alt = el.getAttribute('data-ksbw-pre'); else el.textContent = el.getAttribute('data-ksbw-pre'); });

  /* D4 (owner yes 3 Nov 2026, one click = early access): the »Få tidlig adgang« button in the mails N01, N05 and N06 links to
     /pages/black-week?tidlig=1. Before the early-access hour that visit counts as a sign-up: it sets the same flag a finished form sets (below),
     so the page, the bar and the popup show »Du er på listen« and the popup does not ask again. Klaviyo has the click itself (segment Rgd9X3);
     nothing is sent from here. In the phases early, open and after (also ?ksbw=… in a preview) the parameter does nothing. */
  if (phase === 'pre' && /[?&]tidlig=1(?:&|$)/.test(w.location.search)) { var s1 = get(); if (!s1.signed) { s1.signed = Date.now(); put(s1); } }

  /* ---- the sign-up (popup and Black Week page) ---- */
  function send(form) {
    var mail = form.querySelector('input[type=email]'), ok = form.querySelector('input[name=consent]'), err = form.querySelector('[data-ksbw-err]');
    function fail(msg, el) { err.textContent = msg; err.hidden = false; if (el) { el.setAttribute('aria-invalid', 'true'); el.focus(); } }
    err.hidden = true; mail.removeAttribute('aria-invalid');
    var v = (mail.value || '').replace(/^\s+|\s+$/g, '');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { fail('Skriv en gyldig e-mail, fx navn@email.dk.', mail); return; }
    if (!ok.checked) { fail('Sæt flueben, så vi må sende dig mailen med adgang.', ok); return; }
    var btn = form.querySelector('button[type=submit]'); btn.disabled = true;
    var body = { data: { type: 'subscription', attributes: {
      custom_source: 'BW26 tidlig adgang (' + (form.getAttribute('data-ksbw-src') || 'popup') + ')',
      profile: { data: { type: 'profile', attributes: { email: v,
        properties: { bw26_early: true, signup_source: 'bw26_' + (form.getAttribute('data-ksbw-src') || 'popup'), signup_page: w.location.pathname, market: 'dk' },
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: LIST } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      var s = get(); s.signed = Date.now(); put(s); done(form);
    })['catch'](function () { btn.disabled = false; fail('Det gik ikke lige nu. Prøv igen om et øjeblik.'); });
  }
  function done(form) {
    var box = form.closest('[data-ksbw-box]');
    if (box) { box.querySelector('[data-ksbw-form-wrap]').hidden = true; box.querySelector('[data-ksbw-done]').hidden = false; }
    else { var p = d.createElement('p'); p.className = 'ksbw__inline-done'; p.setAttribute('role', 'status');
      p.textContent = 'Du er på listen. Torsdag 12. november kl. 19.00 får du en mail med adgang – fem timer før alle andre.'; form.parentNode.replaceChild(p, form); }
    bar();
  }
  Array.prototype.forEach.call(d.querySelectorAll('[data-ksbw-form]'), function (f) {
    if (!f.closest('[data-ksbw-box]')) f.setAttribute('data-ksbw-src', 'page');
    f.addEventListener('submit', function (e) { e.preventDefault(); send(f); });
  });

  /* ---- the Black Week page: show the parts for the phase ---- */
  Array.prototype.forEach.call(d.querySelectorAll('[data-ksbw-phase]'), function (el) {
    el.hidden = (' ' + el.getAttribute('data-ksbw-phase') + ' ').indexOf(' ' + phase + ' ') < 0;
  });
  if (get().signed) Array.prototype.forEach.call(d.querySelectorAll('[data-ksbw-page] [data-ksbw-form]'), function (f) { done(f); });
  var cnt = d.querySelector('[data-ksbw-count]');
  /* 1 Nov (DE in-context F09, .se/.de reviews): units that are zero are left out (»5 timer og 12 minutter«, never »0 dage, 5 timer«), the
     singular is used (1 dag, 1 time, 1 minut) and a number stays with its unit (U+00A0) */
  function cdWords(dd, hh, mm) {
    if (!dd && !hh && !mm) mm = 1;
    var p = [];
    if (dd) p.push(dd + ' ' + (dd === 1 ? 'dag' : 'dage'));
    if (hh) p.push(hh + ' ' + (hh === 1 ? 'time' : 'timer'));
    if (mm) p.push(mm + ' ' + (mm === 1 ? 'minut' : 'minutter'));
    return p.length > 1 ? p.slice(0, -1).join(', ') + ' og ' + p[p.length - 1] : p[0];
  }
  function tick() {
    var s = Math.max(0, Math.floor((EARLY - Date.now()) / 1000)), dd = Math.floor(s / 86400), hh = Math.floor(s % 86400 / 3600), mm = Math.floor(s % 3600 / 60);
    cnt.textContent = s ? 'Tidlig adgang åbner om ' + cdWords(dd, hh, mm) : 'Tidlig adgang er åben';
  }
  if (cnt && phase === 'pre') { tick(); setInterval(tick, 30000); }

  if (!root || !root.hasAttribute('data-ksbw') || phase === 'after') return;
  var overlay = root.querySelector('[data-ksbw-overlay]'), box = root.querySelector('[data-ksbw-box]'), barEl = root.querySelector('[data-ksbw-bar]');
  var barText = root.querySelector('[data-ksbw-bar-text]'), last = null, opened = false;

  if (phase === 'early') {
    root.querySelector('[data-ksbw-when]').textContent = 'Tidlig adgang er åben – skriv dig op, så får du linket med det samme';
    root.querySelector('[data-ksbw-done-text]').textContent = 'Linket til Black Week er på vej i din indbakke. Kan du ikke finde det, så kig i din spam-mappe.';
  }
  /* the popup's countdown (#380): days, hours and minutes; on the last day hours, minutes and seconds – never seconds ticking for weeks */
  var clock = root.querySelector('[data-ksbw-clock]');
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function clockTick() {
    var s = Math.max(0, Math.floor((EARLY - Date.now()) / 1000));
    if (!s) { clock.hidden = true; root.querySelector('[data-ksbw-when]').textContent = 'Tidlig adgang er åben'; return; }
    if (overlay.hidden && !clock.hidden) return;
    var dd = Math.floor(s / 86400), hh = Math.floor(s % 86400 / 3600), mm = Math.floor(s % 3600 / 60), ss = s % 60;
    var u = { d: String(dd), h: two(hh), m: two(mm), s: two(ss) }, k, LBL = { d: ['dag', 'dage'], h: ['time', 'timer'] };   /* »1 dag«, »1 time« */
    for (k in u) { var el = clock.querySelector('[data-ksbw-u="' + k + '"]'); el.querySelector('b').textContent = u[k]; if (LBL[k]) el.querySelector('small').textContent = LBL[k][+u[k] === 1 ? 0 : 1]; }
    clock.querySelector('[data-ksbw-u="d"]').hidden = dd === 0;
    clock.querySelector('[data-ksbw-u="s"]').hidden = dd > 0;
    clock.setAttribute('aria-label', 'Tidlig adgang åbner om ' + cdWords(dd, hh, mm));
    clock.hidden = false;
  }
  if (clock && phase === 'pre') { clockTick(); setInterval(clockTick, 1000); }
  function bar() {
    if (!barEl) return;
    var s = get();
    if (phase === 'open') { barText.textContent = 'BLACK WEEK ER ÅBEN · TIL OG MED 30. NOVEMBER'; barEl.hidden = false; }
    else { barText.textContent = s.signed ? 'DU ER PÅ LISTEN · TORSDAG KL. 19' : 'FÅ TIDLIG ADGANG · 12. NOV. KL. 19'; barEl.hidden = !!opened; }
    d.documentElement.classList.toggle('ksbw-bar-on', !barEl.hidden);   /* phones: the chat and cookie buttons move up (ks-bw-lead.css) */
  }
  /* a button, not a link: the theme's page transition follows links before this script could stop it */
  barEl.addEventListener('click', function () { if (phase === 'open' || get().signed) w.location.href = root.getAttribute('data-page') || '/pages/black-week'; else open(); });

  /* fixed layers have no offsetParent, so »shown« is read from the style and the box */
  function shown(el) { if (!el) return false; var cs = w.getComputedStyle(el); return cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity !== 0 && el.getBoundingClientRect().height > 0; }
  function busy() {
    if (shown(d.getElementById('coiOverlay'))) return true;
    var o = d.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < o.length; i++) { if (o[i] !== box && shown(o[i]) && (o[i].classList.contains('is-open') || o[i].closest('.is-open'))) return true; }
    if (d.querySelector('[data-nav-item].is-open')) return true;   /* pre-launch test: an open desktop mega menu */
    return d.documentElement.classList.contains('menu-open') || d.body.classList.contains('menu-open');
  }
  function open() {
    if (opened) return; opened = true; last = d.activeElement; overlay.hidden = false; barEl.hidden = true; d.documentElement.classList.remove('ksbw-bar-on');
    d.documentElement.classList.add('ksbw-lock');
    var f = box.querySelector('input[type=email]'); (f && !box.querySelector('[data-ksbw-form-wrap]').hidden ? f : box).focus();
  }
  function close() {
    opened = false; overlay.hidden = true; d.documentElement.classList.remove('ksbw-lock');
    var s = get(); if (!s.signed) { s.closed = Date.now(); put(s); }
    bar(); if (last && last !== d.body && last.focus && d.contains(last)) last.focus(); else if (!barEl.hidden) barEl.focus();
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-ksbw-close]'), function (b) { b.addEventListener('click', close); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  d.addEventListener('keydown', function (e) {
    if (!opened) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') { var f = box.querySelectorAll('a[href], button:not([disabled]), input'), v = [];
      for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) v.push(f[i]);
      if (!v.length) return; var a = v[0], z = v[v.length - 1];
      if (e.shiftKey && d.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); } }
  });

  /* Never on top of the buy path or an open window (owner 31 Oct 2026): ks-bw-lead.css hides the bar with :has(); this keeps the same
     rule in browsers without :has(), checked every 300 ms and right after each tap; the open Diverge chat counts too (1 Nov 2026) */
  function covered() { return busy() || !!d.querySelector('.ks-root .drawer.is-open, .k3-sheet.is-open, .k3-pop:not([hidden]), #chat-container.chat-open') || d.documentElement.classList.contains('ks-sticky-on'); }
  function mute() { if (!barEl) return; var m = covered(); barEl.classList.toggle('is-muted', m);
    d.documentElement.classList.toggle('ksbw-bar-on', !barEl.hidden && !m); }   /* the chat and cookie buttons drop back down while the bar is away */
  setInterval(mute, 300);
  d.addEventListener('click', function () { setTimeout(mute, 0); setTimeout(mute, 350); }, true);

  bar();
  if (phase === 'open') return;
  var s0 = get(), H = (+root.getAttribute('data-reshow') || 24) * 36e5;
  if (s0.signed || (s0.closed && now - s0.closed < H)) return;
  var fired = false;
  function fire() { if (fired) return; if (busy()) { setTimeout(fire, 1500); return; } fired = true; open(); }
  setTimeout(fire, (+root.getAttribute('data-delay') || 15) * 1000);
  var P = (+root.getAttribute('data-scroll') || 30) / 100;
  w.addEventListener('scroll', function sc() {
    var h = d.documentElement.scrollHeight - w.innerHeight;
    if (h > 0 && w.pageYOffset / h >= P) { w.removeEventListener('scroll', sc); fire(); }
  }, { passive: true });
  if (w.matchMedia && w.matchMedia('(pointer: fine)').matches) d.addEventListener('mouseout', function ex(e) {
    if (!e.relatedTarget && e.clientY <= 0) { d.removeEventListener('mouseout', ex); fire(); }
  });
})(window, document);
